import mutations from './ehr.mutations'
import actions from './ehr.actions'
import getters from './ehr.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
